function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2506",
  fill: "none",
  d: "M-328-651.739H13.8V-844H-328z",
  transform: "translate(328 844)"
}));

var _ref3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-6"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2515",
  fill: "none",
  d: "M26-433l19.976 53.647-4.18 1.764 9.562 4.4 3.48-9.906-4.071 1.716L26-433",
  clipRule: "evenodd",
  transform: "translate(-26 433)"
}));

function SvgLogosmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master-artboard",
    viewBox: "0 0 232.71224975585938 277.9755554199219",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 336 235.2"
    },
    width: "232.71224975585938px",
    height: "277.9755554199219px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _ref2, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    d: "M20.65-381.989L4.621-433 0-368.023l20.65-13.966",
    className: "cls-2",
    transform: "translate(0 433)",
    style: {
      fill: "rgb(255, 255, 255)",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    d: "M-328-651.739H13.8V-844H-328z",
    className: "cls-3",
    transform: "translate(328 844)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    d: "M75.845-390.956L26-433l25.316 47.353 24.529-5.309",
    className: "cls-2",
    transform: "translate(-26 433)",
    style: {
      fill: "rgb(255, 255, 255)",
      clipRule: "evenodd"
    }
  })), _ref3), /*#__PURE__*/React.createElement("rect", {
    id: "ee-background",
    x: 0,
    y: 0,
    width: 232.71224975585938,
    height: 277.9755554199219,
    style: {
      fill: "white",
      fillOpacity: 0,
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.095998287200928, 0, 0, 4.095998287200928, -234.00807189941406, -296.0580635070801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1751",
    transform: "translate(328 844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1746",
    clipPath: "url(#clip-path-2)",
    transform: "translate(-269.61 -770.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1745",
    className: "cls-9",
    transform: "translate(-58.39 -73.166)",
    style: {
      clipPath: "url('#clip-path-3')"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2507",
    d: "M-5-438h22.43v66.757H-5z",
    className: "cls-3",
    transform: "translate(62.5 510.276)",
    style: {
      fill: "rgb(29, 58, 73)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1748",
    clipPath: "url(#clip-path-4)",
    transform: "translate(-264.981 -770.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1747",
    className: "cls-9",
    transform: "translate(-63.019 -73.166)",
    style: {
      clipPath: "url('#clip-path-3')"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    d: "M21-438h51.626v49.133H21z",
    className: "cls-3",
    transform: "translate(41.129 510.276)",
    style: {
      fill: "rgb(29, 58, 73)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1750",
    clipPath: "url(#clip-path-6)",
    transform: "translate(-264.981 -770.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1749",
    className: "cls-5",
    transform: "translate(-63.019 -73.166)",
    style: {
      clipPath: "url('#clip-path')"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    d: "M21-438h30.619v61.595H21z",
    className: "cls-3",
    transform: "translate(41.129 510.276)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosmall);
export default __webpack_public_path__ + "static/media/logosmall.920aef65.svg";
export { ForwardRef as ReactComponent };